import {
  BRANCH_FETCH_REQUEST,
  BRANCH_FETCH_REQUEST_SUCCESS,
  BRANCH_FETCH_REQUEST_FAILURE,
  BRANCH_ADD_REQUEST,
  BRANCH_ADD_REQUEST_SUCCESS,
  BRANCH_ADD_REQUEST_FAILURE,
  BRANCH_UPDATE_REQUEST,
  BRANCH_UPDATE_REQUEST_SUCCESS,
  BRANCH_UPDATE_REQUEST_FAILURE,
  BRANCH_CLEAN_REQUEST,
  BRANCH_CODE_FETCH_REQUEST,
  BRANCH_CODE_FETCH_REQUEST_SUCCESS,
  BRANCH_CODE_FETCH_REQUEST_FAILURE,
  BRANCH_CODE_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const branchesReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case BRANCH_FETCH_REQUEST:
    case BRANCH_ADD_REQUEST:
    case BRANCH_UPDATE_REQUEST:
    case BRANCH_CODE_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case BRANCH_FETCH_REQUEST_SUCCESS:
    case BRANCH_CODE_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.pageSize,
          total: action.data.totalRecord,
          totalPage: action.data.totalPage,
          showSizeChanger: true,
        },
      });

    case BRANCH_ADD_REQUEST_SUCCESS:
    case BRANCH_UPDATE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case BRANCH_FETCH_REQUEST_FAILURE:
    case BRANCH_ADD_REQUEST_FAILURE:
    case BRANCH_UPDATE_REQUEST_FAILURE:
    case BRANCH_CODE_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case BRANCH_CLEAN_REQUEST:
    case BRANCH_CODE_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    default:
      return state;
  }
};

export default branchesReducer;
